import React from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import Breadcrumb from "../components/Breadcrumb";
import AdvisoryArea from "../components/AdvisoryArea";
import FooterFour from "../components/FooterFour";
import NavBarThree from "../components/NavbarThree";

const FundAdvisory = () => {
  return (
    <>
      <SEO canonical="/funding/advisory" {...PAGES["/funding/advisory"]} />
      {/* Navigation Bar */}
      <NavBarThree />

      {/* Navigation Bar */}
      <Breadcrumb title={"Evolvelab Advisory"} />

      {/* Service Details Area */}
      <AdvisoryArea />

      {/* Footer One */}
      <FooterFour />
    </>
  );
};

export default FundAdvisory;
